import { TicketPriority } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/enums/ticket-priority.enum';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useCpmsBoUpdateTicketMutation } from '@service/cpms-bo-ticket.service';

import { PriorityPopoverComponent } from '../shared/priority-selection/priority-popover.component';

interface UpdatePriorityComponentProps {
  priority: TicketPriority;
  id: string;
}

export const UpdatePriorityComponent = ({
  priority,
  id,
}: UpdatePriorityComponentProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [updateTicket] = useCpmsBoUpdateTicketMutation();

  const handleSelect = (newPriority: TicketPriority) => {
    if (newPriority === priority) return;

    updateTicket({ id, priority: newPriority })
      .unwrap()
      .then(() => {
        toast.success(t('$.ticket-details.priority-edit.success'));
      })
      .catch(() => {
        toast.error(t('$.ticket-details.priority-edit.error'));
      });
  };

  return (
    <PriorityPopoverComponent priority={priority} onSelect={handleSelect} />
  );
};
